module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user != '') ? _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "subpage-head-image",
    staticStyle: {
      "background-image": "url('assets/img/subpage-head.jpg')"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.title.main) + "\n        "), _c('span', [_vm._v(_vm._s(_vm.title.sub))])])])]), _vm._v(" "), _c('div', {
    staticClass: "submenu clearfix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "submenu-ul"
  }, [_c('li', {
    class: {
      active: this.$route.params.page == 'osztondij'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changePage('osztondij')
      }
    }
  }, [_vm._v("Ösztöndíjak")])]), _vm._v(" "), _c('li', {
    class: {
      active: this.$route.params.page == 'szerv_jel'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changePage('szerv_jel')
      }
    }
  }, [_vm._v("Szervezeti jelentkezés")])]), _vm._v(" "), _c('li', {
    class: {
      active: this.$route.params.page == 'rendszeres_szocialis_osztondij'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changePage('rendszeres_szocialis_osztondij')
      }
    }
  }, [_vm._v("Rendszeres Szociális Ösztöndíj")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "title": "EKÖP"
    }
  }, [_vm._v("EKÖP-24")]), _vm._v(" "), _c('ul', [_c('li', {
    class: {
      active: this.$route.params.page == 'ekop_adategyeztetes'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changePage('ekop_adategyeztetes')
      }
    }
  }, [_vm._v("EKÖP-24 Adategyeztetés")])]), _vm._v(" "), _c('li', {
    class: {
      active: this.$route.params.page == 'ekop_beszamolo_24_10'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changePage('ekop_beszamolo_24_10')
      }
    }
  }, [_vm._v("EKÖP-24 10 havi Szakmai Záró Beszámoló")])]), _vm._v(" "), _c('li', {
    class: {
      active: this.$route.params.page == 'ekop_beszamolo_24_5'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changePage('ekop_beszamolo_24_5')
      }
    }
  }, [_vm._v("EKÖP-24 5 havi Szakmai Záró Beszámoló")])]), _vm._v(" "), _c('li', {
    class: {
      active: this.$route.params.page == 'ekop_tanulmanykotet' && this.$route.query.y == '24'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changePage('ekop_tanulmanykotet?y=24')
      }
    }
  }, [_vm._v("EKÖP-24 Tanulmánykötet")])]), _vm._v(" "), _c('li', {
    class: {
      active: this.$route.params.page == 'ekop_konferencia' && this.$route.query.y == '24'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changePage('ekop_konferencia?y=24')
      }
    }
  }, [_vm._v("EKÖP-24 Konferencia")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "title": "EKÖP"
    }
  }, [_vm._v("EKÖP-KDP")]), _vm._v(" "), _c('ul', [_c('li', {
    class: {
      active: this.$route.params.page == 'ekop_kdp_szakmai_beszamolo'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changePage('ekop_kdp_szakmai_beszamolo')
      }
    }
  }, [_vm._v("Szakmai beszámoló 2024/2025/1 félév")])]), _vm._v(" "), _c('li', {
    class: {
      active: this.$route.params.page == 'ekop_kdp_tanulmanykotet' && this.$route.query.y == '24'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changePage('ekop_kdp_tanulmanykotet?y=24')
      }
    }
  }, [_vm._v("EKÖP-KDP-24 Tanulmánykötet")])]), _vm._v(" "), _c('li', {
    class: {
      active: this.$route.params.page == 'ekop_kdp_konferencia' && this.$route.query.y == '24'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.changePage('ekop_kdp_konferencia?y=24')
      }
    }
  }, [_vm._v("EKÖP-KDP-24 Konferencia")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "title": "SZE Ágazati Együttműködési Ösztöndíj szakmai beszámoló"
    },
    on: {
      "click": function($event) {
        _vm.changePage('sze_agazati_egyuttm_osztondij_szakmai_beszamolo')
      }
    }
  }, [_vm._v("SZE Ágazati Együttműködési Ösztöndíj szakmai beszámoló")])]), _vm._v(" "), _c('li', {
    class: {
      active: this.$route.params.page == 'jegyzettamogatas'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "title": "Jegyzettámogatás"
    },
    on: {
      "click": function($event) {
        _vm.changePage('jegyzettamogatas')
      }
    }
  }, [_vm._v("Jegyzettámogatás")])])])])]), _vm._v(" "), (this.$route.params.page == 'osztondij') ? _c('Scholarship') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'szerv_jel') ? _c('Organization') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'tamogatas') ? _c('HATAR') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'tmdk_jel') ? _c('TMDK') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'osztondijszerzodes') ? _c('Osztondijszerzodes') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'osztondijszerzodes_21') ? _c('Osztondijszerzodes21') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'osztondijszerzodes_22') ? _c('Osztondijszerzodes22') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'osztondijszerzodes_23') ? _c('Osztondijszerzodes23') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_tanulmanykotet_19') ? _c('UNKPTanulmanykotet19') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_tanulmanykotet_20') ? _c('UNKPTanulmanykotet20') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_tanulmanykotet_21') ? _c('UNKPTanulmanykotet21') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_tanulmanykotet_22') ? _c('UNKPTanulmanykotet22') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_tanulmanykotet_23') ? _c('UNKPTanulmanykotet23') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo') ? _c('UNKPBeszamolo') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_10') ? _c('UNKPBeszamolo10') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_10_mod') ? _c('UNKPBeszamolo10Mod') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_20_5') ? _c('UNKPBeszamolo205') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_20_7') ? _c('UNKPBeszamolo207') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_20_12') ? _c('UNKPBeszamolo2012') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_konferencia') ? _c('UNKPKonferencia') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_konferencia_21') ? _c('UNKPKonferencia21') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_konferencia_22') ? _c('UNKPKonferencia22') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_konferencia_23') ? _c('UNKPKonferencia23') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_21_5') ? _c('UNKPBeszamolo215') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_21_10') ? _c('UNKPBeszamolo2110') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_21_12') ? _c('UNKPBeszamolo2112') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_22_5') ? _c('UNKPBeszamolo225') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_22_10') ? _c('UNKPBeszamolo2210') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_22_12') ? _c('UNKPBeszamolo2212') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_23_5') ? _c('UNKPBeszamolo235') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_23_6') ? _c('UNKPBeszamolo236') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_23_10') ? _c('UNKPBeszamolo2310') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'unkp_beszamolo_23_12') ? _c('UNKPBeszamolo2312') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'ekop_beszamolo_24_5') ? _c('EKOPBeszamolo245') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'ekop_beszamolo_24_10') ? _c('EKOPBeszamolo2410') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'rendszeres_szocialis_osztondij') ? _c('RendszeresSzocialisOsztondij') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'ekop_adategyeztetes') ? _c('EKOPAadategyeztetes') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'ekop_kdp_szakmai_beszamolo') ? _c('EKOPKDPSzakmaiBeszamolo', {
    attrs: {
      "felev_kod": "2024_25_1"
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.params.page == 'sze_agazati_egyuttm_osztondij_szakmai_beszamolo') ? _c('SZEAgazatiEgyuttmOsztondijSzakmaiBeszamolo', {
    attrs: {
      "felev_kod": "2024_25_1"
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.params.page == 'jegyzettamogatas') ? _c('Jegyzettamogatas') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'ekop_tanulmanykotet') ? _c('EKOPTanulmanykotet') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'ekop_konferencia') ? _c('EKOPKonferencia') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'ekop_kdp_tanulmanykotet') ? _c('EKOPKDPTanulmanykotet') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'ekop_kdp_konferencia') ? _c('EKOPKDPKonferencia') : _vm._e(), _vm._v(" "), (this.$route.params.page == 'tamogatas') ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProfileMenu')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "szechenyi-wrapper container"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "szechenyi-logo-wrapper"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "assets/img/szechenyi2020-compact.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', [_c('small', [_c('b', [_vm._v("Pályázati azonosító:")]), _vm._v(" EFOP-3.4.3-16-2016-00016")])]), _vm._v(" "), _c('div', [_c('small', [_c('b', [_vm._v("Pályázat címe:")]), _vm._v(" Intézményi fejlesztések a felsőfokú oktatás minőségének és hozzáférhetőségének együttes javítása érdekében a Széchenyi István Egyetemen")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50a00c55"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition.vue
// module id = 371
// module chunks = 0